
import React, { useEffect } from 'react';
import { useDatadogMetrics } from '@/hooks/useDatadogMetrics';
import { debugLogger } from '@/utils/debugLogger';

const DatadogMetrics = () => {
  const { collectMetrics } = useDatadogMetrics();

  useEffect(() => {
    const getMetrics = async () => {
      try {
        debugLogger.debug('[DatadogMetrics API] Collecting metrics - public access');
        
        // Collect metrics
        const metrics = await collectMetrics();
        
        // Return pure JSON response
        console.log('Metrics data:', metrics);
        
      } catch (error) {
        debugLogger.error('[DatadogMetrics API] Error collecting metrics:', error);
        console.error('Error collecting metrics:', {
          error: "Internal Server Error",
          message: error instanceof Error ? error.message : "Failed to collect metrics"
        });
      }
    };

    getMetrics();
  }, []);

  // Don't render any UI - this is a pure JSON endpoint
  return null;
};

export default DatadogMetrics;
